webpackJsonp([254089299113206],{

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _DocPage = __webpack_require__(20);
	
	var _DocPage2 = _interopRequireDefault(_DocPage);
	
	var _CodeBlock = __webpack_require__(21);
	
	var _CodeBlock2 = _interopRequireDefault(_CodeBlock);
	
	var _CodeSample = __webpack_require__(5);
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _DocPage2.default,
	    { title: 'Using DayPickerInput' },
	    _react2.default.createElement(
	      'p',
	      null,
	      'The package includes',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/api/DayPickerInput' },
	        _react2.default.createElement(
	          'code',
	          null,
	          '<DayPickerInput />'
	        )
	      ),
	      ', a component rendering an input field and displaying react-day-picker in an overlay.'
	    ),
	    _react2.default.createElement(
	      _CodeBlock2.default,
	      null,
	      'import DayPickerInput from \'react-day-picker/DayPickerInput\';'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'small',
	        null,
	        'If you are using ',
	        _react2.default.createElement(
	          'a',
	          { href: 'https://unpkg.com/' },
	          'unpkg'
	        ),
	        ', the component is available as ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'DayPicker.Input'
	        ),
	        ' global variable.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In its simple form, you use ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'DayPickerInput'
	      ),
	      ' to get the day typed in the input field, or the day picked in the calendar:'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'input-01' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Customizing the DayPicker'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To change how the DayPicker appears in the overlay, use the',
	      ' ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'dayPickerProps'
	      ),
	      'which accepts all the ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/api/DayPicker' },
	        'DayPicker props'
	      ),
	      ':'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'input-02' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Changing the date format'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'As default, the date format is the \u201Dugly\u201D ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'YYYY-M-D'
	      ),
	      '. This is because parsing JavaScript dates from strings is not an easy task, and we don\u2019t want to depend on an external library for doing this.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To customize the way dates are parsed and formatted, for example using your date library of choice, use the',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/api/DayPickerInput#parsedate' },
	        _react2.default.createElement(
	          'code',
	          null,
	          'parseDate'
	        )
	      ),
	      ' ',
	      'and the',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/api/DayPickerInput#formatDate' },
	        _react2.default.createElement(
	          'code',
	          null,
	          'formatDate'
	        )
	      ),
	      ' ',
	      'props. See below for examples using',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://date-fns.org' },
	        'date-fns'
	      ),
	      ' or',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://momentjs.com' },
	        'moment.js'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example using ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'date-fns'
	      )
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'examples/input-date-fns' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example using moment.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If you use ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://momentjs.com' },
	        'moment.js'
	      ),
	      ', we provide an utility for using its parser and formatter functions. See',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/examples/input-moment' },
	        'this example'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'examples/input-moment' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-docs-input-js-ae46a51245bd8d12922f.js